import { useState, useEffect, useRef } from "react";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import AuthService from "../../api/authService";
import toast from "react-hot-toast";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useHistory } from "react-router-dom";
import firebase from "../../config/firebase";
import config from "../../config/config";

function Enter_Password({ formData, setFormStage, onAuthChanged }) {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  
  // Create a ref to hold the abort controller
  const abortControllerRef = useRef(null);
  // Create a ref to track mount status
  const isMounted = useRef(true);

  const history = useHistory();

  // Set up cleanup when component unmounts
  useEffect(() => {
    // Return cleanup function that runs when component unmounts
    return () => {
      // Set mounted flag to false
      isMounted.current = false;
      
      // Abort any pending fetch requests
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  // Safe state update function that only updates if component is mounted
  const safeSetState = (setter) => (...args) => {
    if (isMounted.current) {
      setter(...args);
    }
  };

  // Safe state setters
  const safeSetIsLoading = safeSetState(setIsLoading);
  const safeSetError = safeSetState(setError);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  
  const onSubmit = async () => {
    console.log("onSubmit formData : ", formData);
  
    if (!password.trim()) {
      safeSetError("Password is required");
      return;
    }
  
    safeSetIsLoading(true);
    safeSetError("");
    
    // Create a new AbortController for this request
    abortControllerRef.current = new AbortController();
    const { signal } = abortControllerRef.current;
  
    try {
      const response = await fetch(
        `${config.authService}admin/login`, 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData?.email,
            password: password,
            Firm: formData.user.Firm,
            deviceDetails: {
              deviceType: "web",
              os: window.navigator.platform,
              model: window.navigator.userAgent,
              appVersion: "1.0.0",
            },
          }),
          signal, // Pass the abort signal to fetch
        }
      );
  
      // If component unmounted during fetch, stop processing
      if (!isMounted.current) return;
      
      const data = await response.json();
      console.log('data response.json() : ', data);
      
      // If component unmounted while parsing JSON, stop processing
      if (!isMounted.current) return;
      console.log('response.status : ', response.status)
      if (data.status === 200 && formData) {
        // Store user data
        sessionStorage.setItem("User", JSON.stringify(formData.user));
        localStorage.setItem("User", JSON.stringify(formData.user));
        localStorage.setItem("Firm", JSON.stringify(formData.user.Firm));
        localStorage.setItem("firm", formData.user.Firm);

        // Handle notifications with safety checks
        if ("Notification" in window) {
          try {
            const permission = await Notification.requestPermission();
            
            // Check mount status after each async operation
            if (!isMounted.current) return;
            
            if (permission === "granted") {
              let fcmToken;
              try {
                fcmToken = await firebase.messaging().getToken();
                
                // Check mount status again
                if (!isMounted.current) return;
                
                if (fcmToken) {
                  const authService = new AuthService();
                  // We don't need to await this since we're already navigating
                  authService.updateFCMtokenofUser(formData.email, fcmToken)
                    .catch(err => {
                      // Only log error, don't affect user flow
                      console.error("FCM token update error:", err);
                    });
                }
              } catch (fcmErr) {
                console.error("FCM token error:", fcmErr);
                // Continue with login flow even if FCM fails
              }
            }
          } catch (notifErr) {
            console.error("Notification permission error:", notifErr);
            // Continue with login flow even if notification fails
          }
        }
        
        // Final mount check before UI changes
        if (!isMounted.current) return;
        
        console.log('from enter password : ', {
          ...formData.user,
        });
        
        onAuthChanged({
          ...formData.user,
        });

        toast.success("Successfully Verified");
        history.push("/");
      } else {
        safeSetError(data.statusMsg || "Login failed");
      }
    } catch (err) {
      // Only handle error if it's not an abort error and component is mounted
      if (err.name !== 'AbortError' && isMounted.current) {
        safeSetError("An error occurred while logging in");
        console.error(err);
      }
    } finally {
      // Final state update with safety check
      safeSetIsLoading(false);
    }
  };

  const onKeyPressed = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSubmit();
    }
  };

  const buttonStyle = {
    width: "100%",
    padding: "12px 20px",
    fontSize: "15px",
    fontWeight: 500,
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0055A4",
    color: "#ffffff",
  };

  const backButtonStyle = {
    background: "none",
    border: "none",
    color: "#ffffff",
    fontSize: "14px",
    cursor: "pointer",
    textDecoration: "underline",
    padding: "5px",
    fontWeight: 500,
    marginTop: "10px",
  };

  return (
    <div style={{ marginTop: "3em" }}>
      <TextField
        style={{
          backgroundColor: "#fff",
          width: "100%",
          borderRadius: "6px",
          minWidth: 80,
          fontSize: "17px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}
        error={!!error}
        variant="outlined"
        placeholder="Password"
        name="password"
        type={showPassword ? "text" : "password"}
        value={password}
        autoComplete="current-password"
        onKeyDown={onKeyPressed}
        onChange={(e) => {
          setPassword(e.target.value);
          if (e.target.value.trim()) setError("");
        }}
        helperText={error}
        InputProps={{
          style: {
            paddingRight: "8px",
            fontFamily: "'Segoe UI', Arial, sans-serif",
            color: "#333",
            height: "48px",
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
                style={{ padding: "8px", marginRight: "0" }}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <div style={{ paddingTop: "20px", marginBottom: "15px" }}>
        {isLoading ? (
          <button style={buttonStyle} disabled>
            <span style={{ marginRight: "10px" }}>Authenticating</span>
            <div
              className="spinner"
              style={{
                width: "16px",
                height: "16px",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                borderRadius: "50%",
                borderTopColor: "#ffffff",
                animation: "spin 1s linear infinite",
              }}
            ></div>
          </button>
        ) : (
          <button
            style={buttonStyle}
            onClick={onSubmit}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = "#004183";
              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = "#0055A4";
              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
            }}
          >
            Sign In
          </button>
        )}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          style={backButtonStyle}
          onClick={() => setFormStage(0)}
          onMouseOver={(e) => {
            e.currentTarget.style.color = "#fdd34d";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.color = "#ffffff";
          }}
        >
          Back to Email
        </button>

        <button
          style={{
            ...backButtonStyle,
            textAlign: "right",
          }}
          onClick={() => setFormStage(4)}
          onMouseOver={(e) => {
            e.currentTarget.style.color = "#fdd34d";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.color = "#ffffff";
          }}
        >
          Forgot Password?
        </button>
      </div>

      <style jsx>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}

export default Enter_Password;